import {TaskTotalsHeaders as Totals} from '../renders/TaskTotalsHeaders';
import React from 'react';

export const useGroupColumns = customFieldColumnCount => {
	const columns = [
		{
			key: 'name',
			Total: ({row}) => <span>{row?.generatedName || row?.name}</span>,
		},
		{key: 'indicator'},
		{key: 'project'},
		{key: 'project_deadline'},
		{key: 'project_stage'},
		{key: 'rateCard'},
		{key: 'client'},
		{key: 'task_startDate'},
		{key: 'task_endDate'},
		{key: 'task_createdAt'},
		{key: 'role'},
		{key: 'assignees'},
		{key: 'status'},
		{key: 'phase'},
		{key: 'phase_startDate'},
		{key: 'phase_endDate'},
		{key: 'sprint'},
		{key: 'sprint_startDate'},
		{key: 'sprint_endDate'},
		{key: 'progress'},
		{
			key: 'hours-estimated',
			Total: ({row}) => <Totals.EstimateHours totals={row.taskTotals} />,
		},
		{
			key: 'hours-actual',
			Total: ({row}) => <Totals.ReportedHours totals={row.taskTotals} />,
		},
		{
			key: 'hours-actual-billable',
			Total: ({row}) => <Totals.BillableActualHours totals={row.taskTotals} />,
		},
		{
			key: 'hours-actual-non-billable',
			Total: ({row}) => <Totals.NonBillableActualHours totals={row.taskTotals} />,
		},
		{
			key: 'remaining-work-hours',
			Total: ({row}) => <Totals.RemainingHours totals={row.taskTotals} />,
		},
		{
			key: 'projected-total-hours',
			Total: ({row}) => <Totals.ProjectedHours totals={row.taskTotals} />,
		},
		{
			key: 'estimated-points',
			Total: ({row}) => <Totals.EstimatePoints totals={row.taskTotals} />,
		},
		{
			key: 'remaining-work-points',
			Total: ({row}) => <Totals.RemainingPoints totals={row.taskTotals} />,
		},
		{
			key: 'estimated-billable-value-of-service',
			Total: ({row}) => <Totals.BillablePlannedTimeAndExpenses totals={row.taskTotals} currency={row.currency} />,
		},
		{
			key: 'actual-billable-value-of-service',
			Total: ({row}) => <Totals.BillableActualTimeAndExpenses totals={row.taskTotals} currency={row.currency} />,
		},
		{
			key: 'remaining-work-billable',
			Total: ({row}) => (
				<Totals.BillableForecastTimeAndExpensesToComplete totals={row.taskTotals} currency={row.currency} />
			),
		},
		{
			key: 'projected-total-billable',
			Total: ({row}) => (
				<Totals.BillableTotalTimeAndExpensesAtCompletion totals={row.taskTotals} currency={row.currency} />
			),
		},
		{
			key: 'estimated-revenue',
			Total: ({row}) => <Totals.PlannedRevenue totals={row.taskTotals} currency={row.currency} />,
		},
		{
			key: 'actual-revenue',
			Total: ({row}) => <Totals.ActualRevenue totals={row.taskTotals} currency={row.currency} />,
		},
		{
			key: 'remaining-work-revenue',
			Total: ({row}) => <Totals.TotalForecastRevenueToComplete totals={row.taskTotals} currency={row.currency} />,
		},
		{
			key: 'projected-total-revenue',
			Total: ({row}) => <Totals.TotalRevenueRecognition totals={row.taskTotals} currency={row.currency} />,
		},
		{
			key: 'projected-over-under',
			Total: ({row}) => <Totals.Surplus totals={row.taskTotals} currency={row.currency} />,
		},
		{key: 'approved'},
		{key: 'labels'},
		...Array.from({length: customFieldColumnCount}, (_, index) => ({key: `custom-field-${index}`})),
	];

	return columns;
};
